import { render, staticRenderFns } from "./EmergencyContactModal.vue?vue&type=template&id=325c3a2a"
import script from "./EmergencyContactModal.vue?vue&type=script&lang=js"
export * from "./EmergencyContactModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports